import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";

import FirebaseAuthService from "../../firebase/FirebaseAuthService";

export default function VerifyEmail() {

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);

    //----------------------------------------------------
    // Vérifier si l'utilisateur a validé son email
    //----------------------------------------------------

    const handleCheckVerification = async () => {

        try {

            setLoading(true);

            const verified =
                await FirebaseAuthService.checkEmailVerification();

            if (verified) {

                toast.success(
                    "Votre adresse email est maintenant vérifiée."
                );

                navigate("/");

                window.location.reload();

            } else {

                toast.warning(
                    "Votre adresse email n'est pas encore vérifiée."
                );

            }

        } catch (error) {

            console.error(error);

            toast.error(
                "Impossible de vérifier votre compte."
            );

        } finally {

            setLoading(false);

        }

    };

    //----------------------------------------------------
    // Renvoyer le mail
    //----------------------------------------------------

    const handleResendEmail = async () => {

        try {

            setLoading(true);

            await FirebaseAuthService.resendVerificationEmail();

            toast.success(
                "Un nouvel email de vérification a été envoyé."
            );

        } catch (error) {

            console.error(error);

            toast.error(
                "Impossible d'envoyer le mail."
            );

        } finally {

            setLoading(false);

        }

    };

    //----------------------------------------------------

    return (

        <div className="container mt-5">

            <div className="row justify-content-center">

                <div className="col-md-6">

                    <div className="card shadow">

                        <div className="card-body text-center p-5">

                            <div
                                className="display-3 text-success mb-3"
                            >
                                📧
                            </div>

                            <h3>

                                Vérification de votre adresse email

                            </h3>

                            <p className="text-muted mt-3">

                                Un email de vérification vient d'être envoyé.

                                <br />

                                Cliquez sur le lien reçu dans votre boîte mail.

                            </p>

                            <p className="text-danger">

                                Pensez également à vérifier votre dossier
                                <strong> Spam / Courrier indésirable.</strong>

                            </p>

                            <div className="d-grid gap-3 mt-4">

                                <button
                                    className="btn btn-success"
                                    onClick={handleCheckVerification}
                                    disabled={loading}
                                >

                                    {loading
                                        ? "Vérification..."
                                        : "J'ai vérifié mon adresse"}

                                </button>

                                <button
                                    className="btn btn-outline-primary"
                                    onClick={handleResendEmail}
                                    disabled={loading}
                                >

                                    Renvoyer le mail

                                </button>

                            </div>

                            <hr />

                            <Link
                                to="/login"
                            >

                                Retour à la connexion

                            </Link>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    );

}